import ENVIRONMENT from '@/environments/environment';

import { LeadsInterface } from '../../interfaces/LoginKeysInterface/LoginKeysInterface';
import Api from '../../utils/apiHelper';
import { PasswordChangeRequest, ResetPasswordRequest, TokenRequest } from './authInterface';

const AP_KEY = ENVIRONMENT.DATA_PROVIDER_SECURITY.API_KEY;

const authAPI = {
  // El endpoint OAuth solo acepta form-urlencoded (devuelve 415 con JSON)
  postToken: (data: TokenRequest): Promise<any> => Api.POST(
    ENVIRONMENT.URL_API_AUTH_LOGIN.TOKEN,
    new URLSearchParams({ ...data }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
  ),
  postForgotPasswdLink: ({ username }: any): Promise<any> => Api.POST(
    ENVIRONMENT.URL_API_AUTH_LOGIN.FORGOT_PASSWORD,
    { username },
    {
      headers: { 'x-API-KEY': `${AP_KEY}` },
    },
  ),
  postResetPassword: (data: ResetPasswordRequest): Promise<any> => Api.POST(ENVIRONMENT.URL_API_AUTH_LOGIN.RESET_PASSWORD, data, {
    headers: { 'x-API-KEY': `${AP_KEY}` },
  }),
  postLeads: (): Promise<LeadsInterface> => Api.POST(ENVIRONMENT.URL_API_LEADS, { scope: 'PEPPER_ONE' }),
  // Responde 204 si se ha cambiado la clave. Como /token, solo acepta form-urlencoded
  postPasswordChange: (data: PasswordChangeRequest): Promise<any> => Api.POST(
    ENVIRONMENT.URL_API_AUTH_LOGIN.PASSWORD_CHANGE,
    new URLSearchParams({ ...data }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
  ),
  changePassword: (pass: any): Promise<any> => Api.POST(ENVIRONMENT.URL_API_AUTH_LOGIN.CHANGE_PASSWORD, {
    password: pass,
  }),
};

export const {
  postToken,
  postForgotPasswdLink,
  postResetPassword,
  postLeads,
  postPasswordChange,
  changePassword,
} = authAPI;
